import { ErrorMessage } from 'formik';

import classes from './FormErrorMessage.module.scss';

const FormErrorMessage = ({ className, name }) => {
  let messageClassNames = [classes.text];
  if (className) {
    messageClassNames.push(className);
  }

  return (
    <ErrorMessage
      name={name}
      render={data => {
        const message = typeof data === 'string' ? data : '';
        return (
          <span name={`error-${name}`} className={`medium-12 ${messageClassNames.join(' ')}`}>
            {message}
          </span>
        );
      }}
    />
  );
};

export default FormErrorMessage;
